import { Toast } from '../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { callAPI } from '../../../services/api.service';
import { PaymentHistoryItem } from '../../../interfaces/payment.interface';

export const fetchPaymentHistory = async (
  email: string,
  pageNumber: number
): Promise<{ payments: PaymentHistoryItem[]; totalPages: number } | null> => {
  try {
    const response = await callAPI(
      `user/get-user-payment-history?email=${email}&pageNumber=${pageNumber}`
    );

    if (response?.status === HTTPStatusEnum.OK) {
      return {
        payments: response?.payments,
        totalPages: response?.totalPages
      };
    } else {
      Toast('Something Went Wrong', true);
      return null;
    }
  } catch (error) {
    Toast('Something Went Wrong', true);
    return null;
  }
};
